<template>
  <div class="Incidents">
    <v-container grid-list-md fluid fill-height>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card>
            <v-card-title class="title" justify-space-between>
              Reporte Diario por Hogar
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsRDH === null || loadingRDH">
                  <download-csv
                    :data="dataValsRDH"
                    :name="'Reporte Diario por Hogar.csv'"
                    :labels="labelsRDH"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-actions>
              <v-layout row justify-space-around>
                <v-flex xs11 sm3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuRDH"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha"
                      v-model="dateRDH"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateRDH"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                   >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-spacer/>

              <v-btn
                color="info"
                :disabled="!dateRDH || loadingRDH"
                @click="loadTableRDH(dateRDH)"
              >
                <v-icon left>cloud_download</v-icon>Cargar Fecha
              </v-btn>

              <v-btn
                color="info"
                :disabled="loadingRDH"
                @click="loadTableRDH(null)"
              >
                <v-icon left>cloud_download</v-icon>Cargar Todos
              </v-btn>
            </v-card-actions>

            <v-card-text
              v-if="loadingRDH"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-base
                :headers="headersRDH"
                :dataVals="dataValsRDH"
                :searchActive="true"
                :key="tableRDHKey"
              />
              <!-- FIXME: Cambiar tipo de vista cuando se termine el desarrollo de ver encuesta -->
              <!-- <data-view
                :headers="headersRDH"
                :dataVals="dataValsRDH"
                :searchActive="true"
                :key="tableRDHKey"
              /> -->
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card>
            <v-card-title class="title" justify-space-between>
              Reporte de Incidencias Diaras por Encuestador
              <v-spacer/>

              <v-card-actions>
                <v-btn
                  color="info"
                  :disabled="loadingRIE"
                  @click="loadTableRIE"
                >
                  <v-icon left>cloud_download</v-icon>Cargar
                </v-btn>

                <v-btn
                  color="info"
                  :disabled="dataValsRIE === null || loadingRIE"
                >
                  <download-csv
                    :data="dataValsRIE"
                    :name="'Reporte de Incidencias Diaras por Encuestador.csv'"
                    :labels="labelsRIE"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingRIE"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-base
                :headers="headersRIE"
                :dataVals="dataValsRIE"
                :searchActive="true"
                :key="tableRIEKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card>
            <v-card-title class="title">
              Reporte de Incidencias Diarias
              <v-spacer/>
              <v-card-actions>
                <v-btn
                  color="info"
                  :disabled="dataValsRID.length < 1"
                >
                  <download-csv
                    :data="dataValsRID"
                    :name="'Reporte de Incidencias Diarias.csv'"
                    :labels="labelsRID"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingRID"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-total
                :headers="headersRID"
                :dataVals="dataValsRID"
                :key="tableRIDKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card>
            <v-card-title class="title">
              Reporte de Hogares por Vivienda
              <v-spacer/>
              <v-card-actions>
                <v-btn
                  color="info"
                  :disabled="loadingHV"
                  @click="loadTableHV"
                >
                  <v-icon left>cloud_download</v-icon>Cargar
                </v-btn>

                <v-btn
                  color="info"
                  :disabled="dataValsHV.length < 1 || loadingHV"
                >
                  <download-csv
                    :data="dataValsHV"
                    :name="'Reporte de Hogares por Vivienda.csv'"
                    :labels="labelsHV"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingHV"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                :value="completed"
                color="info"
              >
                {{ progressAdvance }}
                {{ progressTotal }}
              </v-progress-circular>
            </v-card-text>

            <v-card-text v-else-if="dataValsHV.length > 0">
              <data-base
                :headers="headersHV"
                :dataVals="dataValsHV"
                :searchActive="true"
                :key="tableHVKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTotal from '@/components/Tables/TableWithTotals'
// import dataView from '@/components/Tables/TableView'
import dataBase from '@/components/Tables/TableBase'
import JsonCSV from 'vue-json-csv'

export default {
  name: `Incidents`,

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.loadTableRID()
  },

  components: {
    'data-total': dataTotal,
    // 'data-view': dataView,
    'data-base': dataBase,
    'download-csv': JsonCSV
  },

  data: function () {
    return {
      backConf: {
        pathRID: '/ccb/inc_diarias',
        pathRIE: '/ccb/inc_diarias_enc',
        pathRDH: '/ccb/vis_diarias',
        pathHV: '/ccb/vivixvisitadas?page=',
        // pathHV: '/ccb/vivixhogares?page=',
        page: 1
      },

      operativo: null,

      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,
      completed: 0,

      loadingRDH: false,
      loadingRIE: false,
      loadingRID: false,
      loadingHV: false,

      menuRDH: false,
      dateRDH: null,

      headersRDH: [
        // { text: 'Fecha', value: 'fecha' },
        { text: 'Localidad', align: 'left', value: 'localidad' },
        { text: 'Id. Manzana', value: 'mnz_id' },
        { text: 'Id. Manzana IK', value: 'mnz' },
        { text: 'Dirección', value: 'dir' },
        { text: 'Hogar', value: 'hogar' },
        { text: 'Encuestador', value: 'nombre' },
        { text: 'Incidencia', value: 'incidencia' },
        { text: 'Identificador Encuesta', value: 'id_encuesta', sortable: false } // para versión sin visualización
        // { text: 'Encuesta', value: 'id_encuesta', sortable: false } // para versión con visualización
      ],
      labelsRDH: {
        fecha: 'Fecha',
        localidad: 'Localidad',
        mnz_id: 'Id. Manzana',
        mnz: 'Id. Manzana IK',
        dir: 'Dirección',
        hogar: 'Hogar',
        nombre: 'Encuestador',
        incidencia: 'Incidencia',
        id_encuesta: 'Identificador Encuesta'
      },

      dataValsRDH: null,
      tableRDHKey: 0,

      headersRIE: [
        {
          text: 'Fecha',
          align: 'left',
          value: 'fecha',
          str: 'Totales'
        },
        { text: 'Encuestador', value: 'encuestador' },
        { text: 'Hubo Contacto', value: 'hubo_contacto' },
        { text: 'No abren o no hay informante calificado', value: 'no_abre_inf_cali' },
        { text: 'No me quieren atender en ningún momento', value: 'no_atienden_nunca' },
        { text: 'No me pueden atender en este momento', value: 'no_atienden_ahora' },
        { text: 'No me permiten el acceso', value: 'no_permiten_acceso' },
        { text: 'La dirección no corresponde o no existe', value: 'direccion_no_existe' },
        { text: 'Vivienda vacía', value: 'vivi_vacia' },
        { text: 'Contacto efectivo pero abandono la encuesta', value: 'abandono' },
        { text: 'Otros usos', value: 'otros_usos' }
      ],
      labelsRIE: {
        fecha: 'Fecha',
        encuestador: 'Encuestador',
        hubo_contacto: 'Hubo Contacto',
        no_abre_inf_cali: 'No abren o no hay informante calificado',
        no_atienden_nunca: 'No me quieren atender en ningún momento',
        no_atienden_ahora: 'No me pueden atender en este momento',
        no_permiten_acceso: 'No me permiten el acceso',
        direccion_no_existe: 'La dirección no corresponde o no existe',
        vivi_vacia: 'Vivienda vacía',
        abandono: 'Contacto efectivo pero abandono la encuesta',
        otros_usos: 'Otros usos'
      },

      dataValsRIE: null,
      tableRIEKey: 0,

      headersRID: [
        {
          text: 'Fecha',
          align: 'left',
          value: 'fecha',
          str: 'Totales'
        },
        { text: 'Hubo Contacto', value: 'hubo_contacto' },
        { text: 'No abren o no hay informante calificado', value: 'no_abre_inf_cali' },
        { text: 'No me quieren atender en ningún momento', value: 'no_atienden_nunca' },
        { text: 'No me pueden atender en este momento', value: 'no_atienden_ahora' },
        { text: 'No me permiten el acceso', value: 'no_permiten_acceso' },
        { text: 'La dirección no corresponde o no existe', value: 'direccion_no_existe' },
        { text: 'Vivienda vacía', value: 'vivi_vacia' },
        { text: 'Contacto efectivo pero abandono la encuesta', value: 'abandono' },
        { text: 'Otros usos', value: 'otros_usos' }
      ],
      labelsRID: {
        fecha: 'Fecha',
        hubo_contacto: 'Hubo Contacto',
        no_abre_inf_cali: 'No abren o no hay informante calificado',
        no_atienden_nunca: 'No me quieren atender en ningún momento',
        no_atienden_ahora: 'No me pueden atender en este momento',
        no_permiten_acceso: 'No me permiten el acceso',
        direccion_no_existe: 'La dirección no corresponde o no existe',
        vivi_vacia: 'Vivienda vacía',
        abandono: 'Contacto efectivo pero abandono la encuesta',
        otros_usos: 'Otros usos'
      },

      dataValsRID: null,
      tableRIDKey: 0,

      headersHV: [
        {
          text: 'Localidad',
          align: 'left',
          value: 'localidad'
        },
        { text: 'Id. Manzana IK', value: 'manzana' },
        { text: 'Estrato', value: 'estrato' },
        { text: 'Dirección', value: 'direccion' },
        { text: 'Numero de Hogares', value: 'numero_hogares' },
        { text: 'Resultado', value: 'resultado' }
      ],
      labelsHV: {
        localidad: 'Localidad',
        manzana: 'Id. Manzana IK',
        estrato: 'Estrato',
        direccion: 'Dirección',
        numero_hogares: 'Numero de Hogares',
        resultado: 'Resultado'
      },

      dataValsHV: [],
      tableHVKey: 0
    }
  },

  watch: {
    /**
     * Calcula el porcentaje de avance de descarga de la tabla Reporte por Vivienda
     */
    'dataValsHV': function () {
      this.completed = (this.progressAdvance / this.progressTotal) * 100
    }
  },

  methods: {
    /**
     * Carga la tabla Diario por Hogar
     */
    loadTableRDH (date) {
      this.loadingRDH = true
      this.dataValsRDH = []
      let request = {
        method: 'post',
        data: {
          fecha: date,
          operativo: this.operativo
        },
        url: this.backConf.pathRDH
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsRDH = resp.data
          t.loadingRDH = false
          t.tableRDHKey += 1
        })
        .catch(function (err) {
          t.questions = []
          t.loading = false
          console.error(err)
        })
    },

    /**
     * Carga la tabla de Incidencias Diaras por Encuestador
     */
    loadTableRIE () {
      this.loadingRIE = true
      this.dataValsRIE = []
      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathRIE
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsRIE = resp.data
          t.loadingRIE = false
          t.tableRIEKey += 1
        })
        .catch(function (err) {
          t.dataValsRIE = []
          t.loadingRIE = false
          console.error(err)
        })
    },

    /**
     * Carga la tabla de incidencias Diarias
     */
    loadTableRID () {
      this.loadingRID = true
      this.dataValsRID = []
      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathRID
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsRID = resp.data
          t.loadingRID = false
          t.tableRIDKey += 1
        })
        .catch(function (err) {
          t.dataValsRID = []
          t.loadingRID = false
          console.error(err)
        })
    },

    /**
     * Carga la tabla de Hogares por Vivienda
     */
    loadTableHV () {
      this.dataValsHV = []
      this.loadDataHV()
    },

    loadDataHV () {
      this.loadingHV = true
      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathHV + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.progressTotal = resp.data.count
          t.progressAdvance = t.dataValsHV.length

          t.dataValsHV = t.dataValsHV.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.loadDataHV()
          } else {
            t.backConf.page = 1
            t.loadingHV = false
          }
        })
        .catch(function (err) {
          t.dataValsHV = []
          t.loadingHV = false
          console.error(err)
        })
    }
  }
}
</script>
